import React, {memo, useEffect, useState} from 'react';
import {useTheme} from "../../../common/ProjectThemeProvider";
import {useToast} from "../../../common/fusion-ui/provider/ToastProvider";
import {
    boolToYN,
    checkNullArr,
    checkNullStr,
    getJsonValue,
    getDefStr,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    isJsonValueTrue,
    limitStringWords,
    setTabTitle
} from "../../../common/fusion-ui/utils/ReactUtils";
import {printError, printLog} from "../../../common/CommonUtils";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";
import {AdminInterface} from "../../components";
import {sendAdminRequest} from "../../utils/AdminUtils";
import {CssVariant, DefStrNA, IconClass} from "../../../common/fusion-ui/config/FusionConfig";
import {Checkbox, CircleLoading, Flexbox, GridBox, Image, Label, LoadingSection, NullMsgLabel, Section} from "../../../common/fusion-ui";
import {AnimationType, FramerAnimator} from "../../../common/fusion-ui/animation/FramerAnimator";
import {ThemedButton, ThemedIconButton} from "../../../common/components";
import {Tooltip} from "@mui/material";

// https://dribbble.com/shots/22592418-Attio-Email-Sharing-Settings
// https://dribbble.com/shots/24491875-E-Commerce-Admin-Dashboard-Design-Concept
// https://dribbble.com/shots/24428184-Paydo-Saas-Product
// https://dribbble.com/shots/23181238-Team-Management-Dashboard
// https://dribbble.com/shots/22236471-Users
const ModuleAllocationPage = memo(() => {
    const TAG = "ModuleAllocationPage";

    const moduleName = AdminModules.ModuleAllocation;
    const animator = new FramerAnimator();

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();

    const Fields = {
        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',


        currCompanyId: 'currCompanyId',
        currCompanyName: 'currCompanyName',
        currCompanyModulesData: 'currCompanyModulesData',
        currCompanyDataLoading: 'currCompanyDataLoading',
        currCompanyDataFound: 'currCompanyDataFound',
        currCompanyDataLoadingMsg: 'currCompanyDataLoadingMsg',
        currCompanyModuleDataChangesAvail: 'currCompanyModuleDataChangesAvail',

        orgModules: 'orgModules',
        companies: 'companies',
        companiesLoading: 'companiesLoading',
        companiesLoadingMsg: 'companiesLoadingMsg',
        companiesLoadingSuccess: 'companiesLoadingSuccess',
        companiesDataFetched: 'companiesDataFetched',
    };
    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        setTabTitle(moduleName);
        fetchCompanies();
    }, []);

    // useEffect(() => {
    //     log('useEffect.currCompanyModulesData.currCompanyDataFound:', isFieldTrue(Fields.currCompanyDataFound), 'currCompanyModulesData:', checkNullArr(getField(Fields.currCompanyModulesData)), 'submitBtn_disabled:', isFieldTrue(Fields.submitBtn_disabled));
    //     if (isFieldTrue(Fields.currCompanyDataFound) && checkNullArr(getField(Fields.currCompanyModulesData)) && isFieldTrue(Fields.submitBtn_disabled)) {
    //         log('useEffect.currCompanyModulesData.if-true:');
    //         updateField(Fields.submitBtn_disabled, false);
    //     }
    // }, [getField(Fields.currCompanyModulesData)]);

    return (<>
        <AdminInterface moduleName={moduleName} tag={TAG}>
            <div className={``}>
                {<LoadingSection
                    labelClassName={'m-2 w-100 fs-normal'}
                    heightClass={75}
                    color={theme.text70}
                    success={isFieldTrue(Fields.companiesLoadingSuccess)}
                    loading={isFieldTrue(Fields.companiesLoading)}
                    msg={getField(Fields.companiesLoadingMsg)}
                />}

                {(!isFieldTrue(Fields.companiesLoading) && isFieldTrue(Fields.companiesLoadingSuccess)) && <div>
                    {animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(100).renderChildren(<div>
                        {/*page-description*/}
                        <Label className={'text-theme-resp fs-md w-100 px-1x'} textAt={'start'}>
                            {`Manage and customize client module allocations. Select a company to load its modules, then add, edit/rename, or enable/disable them. Streamline control over module visibility for client-specific needs.`}
                        </Label>

                        <GridBox className={'mt-2 px-1'} md={[3, 9]}>
                            {/*companies*/}
                            <Section
                                className={'px-0 py-2 h-100'}
                                borderless={true}
                                shadowVariant={'xs'}
                                title={'Companies'}
                                titleClassName={'fw-semi-bold px-3 fs-normal select-none text-theme-resp-60'}
                                titleAt={'start'}>
                                <div className={'px-3 mt-2x scroller scroller-y-auto scroll-dark'}
                                     style={{maxHeight: '55vh'}}>
                                    {checkNullArr(getField(Fields.companies)) ? getField(Fields.companies).map((item, index) => {
                                        return <div key={index + item.name}>
                                            <div
                                                className={`mb-1x d-flex w-100 jc-start al-center flex-nowrap fd-row cursor-pointer highlight-theme-hover transition-sm rounded-3 px-2 py-1 ${getField(Fields.currCompanyId) == item.id ? 'highlight-theme' : ''}`}
                                                onClick={() => {
                                                    if (item.id != getField(Fields.currCompanyId)) {
                                                        if (isFieldTrue(Fields.currCompanyModuleDataChangesAvail)) {
                                                            if (window.confirm(`Unsaved changes found, are you sure you want to switch?`)) {
                                                                fetchCurrCompanyModulesData(item.id, item.text);
                                                            }
                                                        } else {
                                                            fetchCurrCompanyModulesData(item.id, item.text);
                                                        }
                                                    }
                                                }}>
                                                {/*img*/}
                                                <Image
                                                    wrapperClassName={''}
                                                    className={'rounded-3 border-none'}
                                                    src={getDefStr(item.image, 'https://icons.iconarchive.com/icons/martz90/circle-addon1/256/facebook-pages-icon.png')}
                                                    width={'20px'}
                                                    height={'auto'}
                                                    objectFit={'fill'}
                                                />

                                                {/*name*/}
                                                <div className={'ps-2'}>
                                                    <Label className={'text-theme-resp fs-sm-md text-nowrap cursor-pointer'}
                                                           tooltip={(item.text + '').length >= 20 ? item.text : ''}>
                                                        {limitStringWords(item.text, 20, '', '...')}
                                                    </Label>
                                                </div>
                                            </div>
                                        </div>
                                    }) : <NullMsgLabel className={'fw-semi-bold'} color={theme.text50} textAt={'start'}>
                                        {getField(Fields.companiesLoadingMsg, `No companies available!`)}
                                    </NullMsgLabel>}
                                </div>
                            </Section>

                            {/*modules*/}
                            <Section
                                className={'px-0 py-2 h-100'}
                                borderless={true}
                                shadowVariant={'xs'}
                                title={<div className={'w-100 d-flex flex-wrap fd-row jc-between jc-start-sm al-center al-center-sm'}>
                                    <span className={'text-theme-resp-60'}>
                                            {`Allocate Modules`}{isFieldTrue(Fields.currCompanyDataFound) ? <span className={'text-theme-resp'}>
                                                {` for ${getField(Fields.currCompanyName)} (${getField(Fields.currCompanyId)})`}</span> : ''}
                                    </span>

                                    <Flexbox alignAt={'center'}
                                             disabled={isFieldTrue(Fields.currCompanyDataLoading) || !isFieldTrue(Fields.currCompanyDataFound)}
                                    >
                                        {/*refresh*/}
                                        <ThemedIconButton
                                            className={'p-2 fs-md text-center-force'}
                                            tooltip={'Refresh'}
                                            mr={2}
                                            outlined={true}
                                            size={'24px'}
                                            icon={IconClass.refresh}
                                            borderWidth={0}
                                            asLoading={isFieldTrue(Fields.currCompanyDataLoading)}
                                            disabled={isFieldTrue(Fields.currCompanyDataLoading)}
                                            onClick={() => {
                                                if (isFieldTrue(Fields.currCompanyModuleDataChangesAvail)) {
                                                    if (window.confirm(`Are you sure you want to refresh the table? All the changes will be lost!`)) {
                                                        fetchCurrCompanyModulesData(getField(Fields.currCompanyId), getField(Fields.currCompanyName), false);
                                                    }
                                                } else {
                                                    fetchCurrCompanyModulesData(getField(Fields.currCompanyId), getField(Fields.currCompanyName), false);
                                                }
                                            }}
                                        />

                                        {/*submit*/}
                                        <ThemedButton
                                            className={'w-auto px-2 fs-sm py-1 text-nowrap'}
                                            text={isFieldTrue(Fields.submitBtn_AsLoading) ? 'Saving.....' : 'Save changes'}
                                            asLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                                            disabled={isFieldTrue(Fields.submitBtn_disabled)}
                                            ml={2}
                                            onClick={handleSaveChanges}
                                        />
                                    </Flexbox>
                                </div>}
                                titleColor={theme.text80}
                                titleClassName={'fw-semi-bold px-3 fs-normal'}
                                titleAt={'start'}>
                                <div className={'px-3 mt-2x h-100'}>
                                    {/*loader*/}
                                    {isFieldTrue(Fields.currCompanyDataLoading) && <CircleLoading wrapperHeight={'auto'}/>}

                                    {/*modules-table*/}
                                    {isFieldTrue(Fields.currCompanyDataFound) ? <div>
                                        <div className={'mt-2'}>
                                            {/*<div>currCompanyModulesData: {jsonToStr(getField(Fields.currCompanyModulesData))}</div>*/}
                                            {/*<div>orgModules: {jsonToStr(getField(Fields.orgModules))}</div>*/}
                                            <Section
                                                className={'p-0'}
                                                borderColor={theme.text20}
                                                roundedVariant={3}>
                                                <div className={'w-100 position-relative h-100 scroller scroller-auto scroll-dark'}
                                                     style={{maxHeight: '50vh'}}>
                                                    <table className={'w-100 border-none'}
                                                           style={{color: theme.text}}>
                                                        <thead className={'w-100 position-sticky'}
                                                               style={{top: 0, backgroundColor: theme.bg, zIndex: 5}}>
                                                        <tr>
                                                            <th className={'px-2'}>No.</th>
                                                            <th className={'px-2'}>Name</th>
                                                            <th className={'px-2'}>Allocated Name</th>
                                                            <th className={'px-2 d-flex w-auto jc-center'}>
                                                                <Checkbox
                                                                    wrapperClassName={'w-auto'}
                                                                    className={'fw-bold'}
                                                                    variant={''}
                                                                    color={theme.text}
                                                                    highlightHoverVariant={''}
                                                                    py={0}
                                                                    defaultChecked={checkNullArr(getField(Fields.currCompanyModulesData)) && getField(Fields.currCompanyModulesData).every(item => isBoolTrue(item.isAllocated))}
                                                                    checked={checkNullArr(getField(Fields.currCompanyModulesData)) && getField(Fields.currCompanyModulesData).every(item => isBoolTrue(item.isAllocated))}
                                                                    onChange={(e, value) => {
                                                                        log('cb-all.onChange.value:', value);
                                                                        try {
                                                                            let updatedList = getField(Fields.currCompanyModulesData);
                                                                            updatedList = checkNullArr(updatedList) ? updatedList : [];
                                                                            updatedList = updatedList.map((mapItem) => {
                                                                                return {
                                                                                    ...mapItem, isAllocated: value
                                                                                };
                                                                            });
                                                                            updateField(Fields.currCompanyModulesData, updatedList);
                                                                            updateField(Fields.currCompanyModuleDataChangesAvail, true);
                                                                        } catch (error) {
                                                                            toast('Operation failed, please try again!');
                                                                            logErr(error);
                                                                        }
                                                                    }}>Allocated</Checkbox>
                                                                {/*<span>Allocated</span>*/}
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {getField(Fields.currCompanyModulesData).map((item, index) => {
                                                            const isModuleActive = isBoolTrue(item.status);
                                                            const isModuleAllocated = isBoolTrue(item.isAllocated);
                                                            const allocatedId = item.allocatedId;
                                                            //{ "id": 1, "name": "Web Meeting", "status": false, "allocatedId": 1, "allocatedName": "Online Meetings", "isAllocated": true },
                                                            return <Tooltip key={index + item.name}
                                                                title={!isModuleActive ? `Module is disabled!` : ``}>
                                                                <tr 
                                                                    style={{borderTop: `.5px solid ${isModuleAllocated ? theme.text10 : 'var(--danger12)'}`}}
                                                                    className={`transition-sm ${isModuleActive ? `${!isModuleAllocated ? `highlight-danger-light-hover` : `highlight-theme-hover`}` : `text-theme-resp-50 bg-dark-10`} ${!isModuleAllocated && isModuleActive ? `bg-danger-05 text-danger` : ``}`}>
                                                                    {/*no.*/}
                                                                    <td className={'px-2'}>{index + 1}</td>

                                                                    {/*name*/}
                                                                    <td className={'px-2'}>{item.name}</td>

                                                                    {/*allocatedName*/}
                                                                    <td className={`px-2 ${!checkNullStr(item.allocatedName) ? 'text-theme-resp-40' : ''}`}>
                                                                        <Tooltip title={(item.allocatedName + '').length >= 17 ? item.allocatedName : ''}>
                                                                            <span>
                                                                                {limitStringWords(getDefStr(item.allocatedName, DefStrNA), 16, '', '...')}
                                                                            </span>
                                                                        </Tooltip>

                                                                        {/*delete-btn*/}
                                                                        {checkNullStr(item.allocatedName) && <ThemedIconButton
                                                                            className={'p-2 fs-md-sm text-center-force'}
                                                                            tooltip={'Delete alternate name'}
                                                                            mx={1}
                                                                            outlined={true}
                                                                            size={'18px'}
                                                                            icon={IconClass.delete}
                                                                            disabled={!isModuleActive}
                                                                            borderWidth={0}
                                                                            variant={'var(--danger)'}
                                                                            onClick={() => {
                                                                                try {
                                                                                    let updatedList = getField(Fields.currCompanyModulesData);
                                                                                    updatedList = updatedList.map((mapItem) => {
                                                                                        if (mapItem.allocatedId == allocatedId) {
                                                                                            return {
                                                                                                ...mapItem, allocatedName: ''
                                                                                            };
                                                                                        }
                                                                                        return mapItem;
                                                                                    });
                                                                                    updateField(Fields.currCompanyModulesData, updatedList);
                                                                                    updateField(Fields.currCompanyModuleDataChangesAvail, true);
                                                                                } catch (error) {
                                                                                    toast('Delete failed, please try again!');
                                                                                    logErr(error);
                                                                                }
                                                                            }}
                                                                        />}

                                                                        {/*edit-btn*/}
                                                                        <ThemedIconButton
                                                                            className={'p-2 fs-md-sm text-center-force'}
                                                                            tooltip={checkNullStr(item.allocatedName) ? 'Edit Name' : 'Set alternate name'}
                                                                            ml={checkNullStr(item.allocatedName) ? 1 : 3}
                                                                            outlined={true}
                                                                            size={'18px'}
                                                                            icon={IconClass.edit}
                                                                            disabled={!isModuleActive}
                                                                            borderWidth={0}
                                                                            onClick={() => {
                                                                                try {
                                                                                    const newName = window.prompt(checkNullStr(item.allocatedName) ? 'Edit Name' : 'Set alternate name', getDefStr(item.allocatedName, ''));
                                                                                    log('edit-newName:', newName);
                                                                                    if (checkNullStr(newName)) {
                                                                                        let updatedList = getField(Fields.currCompanyModulesData);
                                                                                        updatedList = updatedList.map((mapItem) => {
                                                                                            if (mapItem.allocatedId == allocatedId) {
                                                                                                return {
                                                                                                    ...mapItem, allocatedName: newName
                                                                                                };
                                                                                            }
                                                                                            return mapItem;
                                                                                        });
                                                                                        updateField(Fields.currCompanyModulesData, updatedList);
                                                                                        updateField(Fields.currCompanyModuleDataChangesAvail, true);
                                                                                    }
                                                                                } catch (error) {
                                                                                    toast('Update failed, please try again!');
                                                                                    logErr(error);
                                                                                }
                                                                            }}
                                                                        />
                                                                    </td>

                                                                    {/*isModuleAllocated-btn*/}
                                                                    <td className={'px-2 text-center'}>
                                                                        <ThemedButton
                                                                            className={'w-auto fs-sm text-nowrap rounded-10'}
                                                                            text={boolToYN(isModuleAllocated)}
                                                                            variant={''}
                                                                            color={isModuleAllocated ? theme.primary : 'var(--danger)'}
                                                                            hoverColor={theme.textWhite}
                                                                            bgColor={isModuleAllocated ? theme.primary30 : 'var(--danger25)'}
                                                                            hoverBgColor={isModuleAllocated ? theme.primary : 'var(--danger)'}
                                                                            rippleColor={theme.textWhite}
                                                                            disabled={!isModuleActive}
                                                                            style={{padding: '.05rem .45rem'}}
                                                                            width={'36px'}
                                                                            height={'18px'}
                                                                            onClick={() => {
                                                                                try {
                                                                                    let updatedList = getField(Fields.currCompanyModulesData);
                                                                                    updatedList = updatedList.map((mapItem) => {
                                                                                        if (mapItem.allocatedId == allocatedId) {
                                                                                            return {
                                                                                                ...mapItem, isAllocated: !isModuleAllocated
                                                                                            };
                                                                                        }
                                                                                        return mapItem;
                                                                                    });
                                                                                    updateField(Fields.currCompanyModulesData, updatedList);
                                                                                    updateField(Fields.currCompanyModuleDataChangesAvail, true);
                                                                                } catch (error) {
                                                                                    toast('Operation failed, please try again!');
                                                                                    logErr(error);
                                                                                }
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            </Tooltip>
                                                        })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Section>
                                        </div>
                                    </div> : !isFieldTrue(Fields.currCompanyDataLoading) &&
                                        <NullMsgLabel className={'fw-semi-bold'} color={theme.text50} textAt={'start'}>
                                            {!checkNullStr(getField(Fields.currCompanyId)) ? 'Please select a company!' : getField(Fields.currCompanyDataLoadingMsg, `No data available!`)}
                                        </NullMsgLabel>}
                                </div>
                            </Section>
                        </GridBox>
                    </div>)}
                </div>}
            </div>
        </AdminInterface>
    </>)

    async function fetchCompanies(checkBefore = true) {
        const fun = 'fetchCompanies:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.companiesDataFetched))) {
            updateField(Fields.companiesDataFetched, true);
            updateField(Fields.companiesLoading, true);
            updateField(Fields.companiesLoadingSuccess, false);
            updateField(Fields.companiesLoadingMsg, null);
            updateField(Fields.companies, []);
            updateField(Fields.currCompanyId, null);
            updateField(Fields.currCompanyName, null);
            updateField(Fields.currCompanyModulesData, {});
            updateField(Fields.currCompanyDataLoading, false);
            updateField(Fields.currCompanyDataFound, false);
            updateField(Fields.currCompanyDataLoadingMsg, null);
            updateField(Fields.currCompanyModuleDataChangesAvail, false);
            try {
                //send-request
                const REQUEST_OPTIONS = {fetchImages: true};
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__moduleAlloc__mainPage_fetch_companies, reqOptions: REQUEST_OPTIONS, onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);
                        const comps = getJsonValueFromNestedKeys(fetchedData, ['data', 'companies'], []);
                        const orgModules = getJsonValueFromNestedKeys(fetchedData, ['data', 'orgModules'], []);
                        const success = checkNullArr(comps);
                        if (success) {
                            updateField(Fields.companies, comps);
                            updateField(Fields.orgModules, orgModules);
                        } else {
                            toast("No companies found!", CssVariant.danger);
                            updateField(Fields.companiesLoadingMsg, "No companies found!");
                        }
                        updateField(Fields.companiesLoading, false);
                        updateField(Fields.companiesLoadingSuccess, success);
                    }), onError: ((error) => {
                        toast("Couldn't load companies, please try again!", CssVariant.danger);
                        updateField(Fields.companiesLoadingMsg, "Couldn't load companies, please try again!");
                        updateField(Fields.companiesLoading, false);
                        updateField(Fields.companiesLoadingSuccess, false);
                        logErr(fun, error);
                    }),
                });
            } catch (error) {
                toast("Couldn't load companies, please try again!", CssVariant.danger);
                updateField(Fields.companiesLoadingMsg, "Couldn't load companies, please try again!");
                updateField(Fields.companiesLoading, false);
                updateField(Fields.companiesLoadingSuccess, false);
                logErr(fun, error);
            }
        }
    }

    async function fetchCurrCompanyModulesData(id, name, checkBefore = true) {
        const fun = 'fetchCurrCompanyModulesData:';

        //Return early if data already fetched
        if (checkBefore && id == getField(Fields.currCompanyId)) {
            return false;
        }

        try {
            updateField(Fields.currCompanyId, id);
            updateField(Fields.currCompanyName, name);
            updateField(Fields.currCompanyModulesData, {});
            updateField(Fields.currCompanyDataLoading, true);
            updateField(Fields.currCompanyDataFound, false);
            updateField(Fields.currCompanyDataLoadingMsg, null);
            updateField(Fields.currCompanyModuleDataChangesAvail, false);

            //send-request
            const REQUEST_OPTIONS = {companyId: id};
            sendAdminRequest({
                reqUrl: AdminReqUrls.admin__moduleAlloc__mainPage_fetch_curr_company_data, reqOptions: REQUEST_OPTIONS, onFetched: ((fetchedData) => {
                    log(fun, 'fetchedData:', fetchedData);
                    const modulesData = getJsonValue(fetchedData, 'data', []);
                    const success = isJsonValueTrue(fetchedData, 'success');
                    const message = getJsonValue(fetchedData, 'message');
                    if (success) {
                        toast(message, CssVariant.success);
                        updateField(Fields.currCompanyModulesData, modulesData);
                    } else {
                        toast(message, CssVariant.danger);
                        updateField(Fields.currCompanyDataLoadingMsg, message);
                    }
                    updateField(Fields.currCompanyDataLoading, false);
                    updateField(Fields.currCompanyDataFound, success);
                }), onError: ((error) => {
                    toast("Couldn't load data, please try again!", CssVariant.danger);
                    updateField(Fields.currCompanyDataLoadingMsg, "Couldn't load data, please try again!");
                    updateField(Fields.currCompanyDataLoading, false);
                    updateField(Fields.currCompanyDataFound, false);
                    logErr(fun, error);
                    updateField(Fields.currCompanyId, null);
                    updateField(Fields.currCompanyName, null);
                }),
            });
        } catch (error) {
            toast("Couldn't load data, please try again!", CssVariant.danger);
            updateField(Fields.currCompanyDataLoadingMsg, "Couldn't load data, please try again!");
            updateField(Fields.currCompanyDataLoading, false);
            updateField(Fields.currCompanyDataFound, false);
            logErr(fun, error);
            updateField(Fields.currCompanyId, null);
            updateField(Fields.currCompanyName, null);
        }
    }

    async function handleSaveChanges() {
        const fun = 'handleSaveChanges:';
        try {
            updateField(Fields.submitBtn_AsLoading, true);
            updateField(Fields.submitBtn_disabled, true);

            //send-request
            const REQUEST_OPTIONS = {companyId: getField(Fields.currCompanyId), modulesData: getField(Fields.currCompanyModulesData)};
            sendAdminRequest({
                reqUrl: AdminReqUrls.admin__moduleAlloc__mainPage_submitChanges,
                reqOptions: REQUEST_OPTIONS,
                onFetched: ((fetchedData) => {
                    log(fun, 'fetchedData:', fetchedData);

                    const success = isJsonValueTrue(fetchedData, 'success');
                    const message = getJsonValue(fetchedData, 'message');
                    if (success) {
                        toast(message, CssVariant.success);
                    } else {
                        toast(message, CssVariant.danger);
                    }
                    updateField(Fields.submitBtn_AsLoading, false);
                    updateField(Fields.submitBtn_disabled, false);
                    updateField(Fields.currCompanyModuleDataChangesAvail, false);
                }),
                onError: ((error) => {
                    toast("Couldn't save changes, please try again!", CssVariant.danger);
                    updateField(Fields.currCompanyDataLoadingMsg, "Couldn't save changes, please try again!");
                    updateField(Fields.submitBtn_AsLoading, false);
                    updateField(Fields.submitBtn_disabled, false);
                    logErr(fun, error);
                }),
            });
        } catch (error) {
            toast("Couldn't save changes, please try again!", CssVariant.danger);
            updateField(Fields.currCompanyDataLoadingMsg, "Couldn't save changes, please try again!");
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }


    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text + '');
        changeToastVariant(variant);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});
export default ModuleAllocationPage;
